import React, { useState, useEffect } from 'react';
import PrivateOwnerProfileView from 'views/profiles/PrivateOwnerProfileView';
import isCrawlers from 'common/utils/isCrawlers';
import { serverFetch } from 'utils/serverFetch';
import { withTranslation } from 'config/i18n';
import axios, { API } from 'config/axios';
import Head from 'next/head';
import generateMetaData from 'utils/generateMetaData';
import useHandleResponse from 'utils/useHandleResponse';
import generateHreflang from 'utils/generateHreflang';
import { getOwnerID, getHostPublicProfileSlug } from 'views/profiles/utils/publicProfileSlugHelper';
import Error from 'components/shared/Error';
import { useRouter } from 'next/router';

const CommercialOwnerProfile = ({
  serverData, ssrRender, errorStatusCode, headLinks,
}) => {
  const [data, setData] = useState(serverData);
  const router = useRouter();
  const { handleError } = useHandleResponse();
  let metaData = null;
  if (data?.meta_data) {
    const seoValues = data.meta_data;
    metaData = {
      title: seoValues.title,
      description: seoValues.description,
      keywords: seoValues.keywords,
      og_title: seoValues.og_title,
      og_description: seoValues.og_description,
    };
  }
  useEffect(() => {
    if (process.browser && !ssrRender && !serverData) {
      const profileID = getOwnerID(router.query.slug);
      axios
        .get(API.profile.owners.replace('{id}', profileID), {
          params: {
            vehicles_page_size: 6,
            reviews_page_size: 6,
          },
        })
        .then((res) => {
          const validSlug = getHostPublicProfileSlug(res.data.data.name, res.data.data.id);
          setData({
            meta_data: res.data.meta_data,
            data: res.data.data,
          });
          if (validSlug !== router.query.slug.toLocaleLowerCase()) {
            router.push(validSlug);
          }
        })
        .catch((err) => {
          handleError(err, false);
        });
    }
  }, []);
  useEffect(() => {
    // console.log('dataaaa', data.data);
  });
  if (errorStatusCode) {
    return <Error statusCode={errorStatusCode || 500} />;
  }
  return (
    <>
      <Head>

        {metaData && generateMetaData(metaData)}
        {!process.browser && (
        <>
          <link rel="canonical" href={headLinks.canonical} />
          {headLinks.urls.map((local) => (
            <link
              key={local.hreflang}
              rel="alternate"
              href={local.url}
              hrefLang={local.hreflang}
            />
          ))}
        </>
        )}

      </Head>
      {data
      && <PrivateOwnerProfileView data={data.data} />}
    </>
  );
};

CommercialOwnerProfile.getInitialProps = async (ctx) => {
  const { res, req } = ctx;
  const ssrRender = req ? isCrawlers(req.headers['user-agent']) : false;
  // const ssrRender = true;

  let serverData = null;
  let error;
  let errorCode;
  // generate canonical and hrefLang
  const host = ctx.req ? ctx.req.headers.host : window.location.host;
  let url;
  ctx.req ? (url = ctx.req.url) : (url = ctx.asPath);

  const headLinks = generateHreflang(
    url,
    `/motorcycle-rentals/${ctx.query.slug}`,
    host,
    null,
    false,
  );

  if (ssrRender) {
    const profileID = getOwnerID(ctx.query.slug);
    if (Number.isNaN(profileID)) {
      errorCode = 404;
    } else {
      const params = {
        vehicles_page_size: 6,
        reviews_page_size: 6,
      };

      const {
        success, data, errorRes,
      } = await serverFetch(
        ctx,
        API.profile.owners.replace('{id}', profileID),
        params,
      );
      if (success && data) {
        const validSlug = getHostPublicProfileSlug(data.data.name, data.data.id);

        if (validSlug !== ctx.query.slug.toLocaleLowerCase()) {
          res.writeHead(302, {
            Location: validSlug,
          });
          res.end();
        }
        serverData = data;
        error = errorRes;
      }
    }
  }

  return {
    namespacesRequired: ['fe_es_profiles'],
    serverData,
    ssrRender,
    pendingOnLayout: false,
    headLinks,
    error,
    errorStatusCode: errorCode || (error?.response && error.response.status), // as error.response is not passed to the browser
  };
};
export default withTranslation('fe_es_profiles')(CommercialOwnerProfile);
